import { render, staticRenderFns } from "./StpPriceField.vue?vue&type=template&id=1c288710&scoped=true"
import script from "./StpPriceField.vue?vue&type=script&lang=js"
export * from "./StpPriceField.vue?vue&type=script&lang=js"
import style0 from "./StpPriceField.vue?vue&type=style&index=0&id=1c288710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c288710",
  null
  
)

export default component.exports